import axios from "axios";
import createPublicApiInstance from '../api';

export function getDataUser(id,authToken) {
	//return axios.get(`${process.env.REACT_APP_DANSUAPI}/private/prestador_prestador/info`);

	const apiInstance = createPublicApiInstance();
	if (!apiInstance) {
		throw new Error('API instance is not available');
	}

	return apiInstance.get(`/prestador/${id}/info?authToken=${authToken}`);

}

export async function updateProvider(id, body) {
	try {
		// const req = await axios.post(`${process.env.REACT_APP_DANSUAPI}/private/prestador_prestador/info`, body);
		// return req.data

		// eslint-disable-next-line no-undef
		const apiInstance = createPublicApiInstance();
		if (!apiInstance) {
			throw new Error('API instance is not available');
		}

		const sisadaResult = await apiInstance.post(`/prestador/${id}/contacto`, body)
		return sisadaResult.data;



	} catch (error) {
		return {error}
	}
}

export async function getValuesProviders(affiliate, plan, provider) {
	try {
		const body = {
			afiliado_id: affiliate,
			plan_id: plan,
			prestacion_id: provider
		}
		const req = await axios.post(`${process.env.REACT_APP_DANSUAPI}/private/orden_prestador/get_valores_prestacion`, body);
		return req.data
	} catch (error) {
		return {error}
	}
}

export async function getProviders(body) {
	try {
		const req = await axios.post(`${process.env.REACT_APP_DANSUAPI}/private/orden_prestador/prestaciones`, body);
		return req.data
	} catch (error) {
		return {error}
	}
}

export async function changePassword(body) {
	try {
		const req = await axios.post(`${process.env.REACT_APP_DANSUAPI}/private/prestador_prestador/change_password`, body);
		return req.data
	} catch (error) {
		return {error}
	}
}

export async function resetPassword(body) {
	try {
		const req = await axios.post(`${process.env.REACT_APP_DANSUAPI}/public/prestador/reset_password`, body);
		return req.data
	} catch (error) {
		return {error}
	}
}

export async function changePasswordToken(token, body) {
	const config = {
		headers: {
			Authorization: 'Bearer ' + token
		}
	}
	try {
		const req = await axios.post(`${process.env.REACT_APP_DANSUAPI}/private/prestador_prestador/change_password`, body, config);
		return req.data
	} catch (error) {
		return {error}
	}
}